import { formatOData } from '@helpers';
import type { ApiConfig, ODataParams } from '@api/types';
import { typedMethodPost, typedMethodGet } from '@api/utils';
import type { DeleteClampingToolRequestDto, StoreClampingToolRequestDto, StoreToolRequestDto } from '@api/generated/models';
import type { ClampingTool, StoreClampingToolResponse, StoreToolResponse } from '@api/domain/types';
import { toClampingTools, toStoreClampingToolResponse, toStoreToolResponse } from '@api/domain/mappers';

export default ({ baseURL, baseURLoData }: ApiConfig) => ({
  get: typedMethodGet<ODataParams, ClampingTool[]>(
    (data) =>
      fetch(`${baseURLoData}/odata/ClampingTool?${formatOData(data.params ?? {})}`, {
        method: 'GET',
        headers: data.headers,
        signal: data.signal,
      }),
    toClampingTools
  ),
  remove: typedMethodPost<DeleteClampingToolRequestDto, void>(
    (data) =>
      fetch(`${baseURL}/v1/clampingTool/delete`, {
        method: 'POST',
        ...data,
      })
  ),
  storeClampingTool: typedMethodPost<StoreClampingToolRequestDto, StoreClampingToolResponse>(
    (data) =>
      fetch(`${baseURL}/v1/clampingTool/store`, {
        method: 'POST',
        ...data,
      }),
    toStoreClampingToolResponse
  ),
  storeTool: typedMethodPost<StoreToolRequestDto, StoreToolResponse>(
    (data) =>
      fetch(`${baseURL}/v1/tool/store`, {
        method: 'POST',
        ...data,
      }),
    toStoreToolResponse
  ),
});

// Re-export types for consumers
export type { ClampingTool, StoreClampingToolResponse, StoreToolResponse } from '../../domain/types';
export type { DeleteClampingToolRequestDto, StoreClampingToolRequestDto, StoreToolRequestDto } from '../../generated/models';
